"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeComments = exports.filterComments = exports.layerCommentIndices = exports.StylableComments = void 0;
var stylable_shorthands_1 = require("./stylable-shorthands");
var COMMENT_START = '/*';
var COMMENT_END = '*/';
var VALUE_WITHIN_COMMENT_REGEX = /\/\*.*\*\//g;
var COMMENT_START_REGEX = /\/\*/g;
var COMMENT_END_REGEX = /\*\//g;
var StylableComments = /** @class */ (function () {
    function StylableComments(value) {
        this.indicesValid = false;
        this.commentIndices = [];
        var commentIndices = layerCommentIndices((0, stylable_shorthands_1.splitLayers)(value));
        if (commentIndices !== null) {
            this.commentIndices = commentIndices;
            this.indicesValid = true;
        }
    }
    StylableComments.prototype.isCommented = function (index) {
        return !!~this.commentIndices.indexOf(index);
    };
    StylableComments.prototype.replaceLayers = function (srcIndex, dstIndex) {
        if (this.commentIndices.length === 0) {
            return;
        }
        var srcIndexComment = this.commentIndices.indexOf(srcIndex);
        var dstIndexComment = this.commentIndices.indexOf(dstIndex);
        if (!!~srcIndexComment && !~dstIndexComment) {
            this.commentIndices[srcIndexComment] = dstIndex;
        }
        else if (!!~dstIndexComment && !~srcIndexComment) {
            this.commentIndices[dstIndexComment] = srcIndex;
        }
    };
    StylableComments.prototype.duplicateLayer = function (index) {
        if (this.commentIndices.length === 0) {
            return;
        }
        for (var i = 0; i < this.commentIndices.length; i++) {
            if (this.commentIndices[i] > index) {
                this.commentIndices[i]++;
            }
        }
        var commentIndex = this.commentIndices.indexOf(index);
        if (~commentIndex) {
            this.commentIndices.splice(commentIndex, 0, index + 1);
        }
    };
    StylableComments.prototype.removeLayer = function (index) {
        if (this.commentIndices.length === 0) {
            return;
        }
        var commentIndex = this.commentIndices.indexOf(index);
        if (~commentIndex) {
            this.commentIndices.splice(commentIndex, 1);
        }
        for (var i = 0; i < this.commentIndices.length; i++) {
            if (this.commentIndices[i] > index) {
                this.commentIndices[i]--;
            }
        }
    };
    StylableComments.prototype.toggleCommentLayer = function (index) {
        var commentIndex = this.commentIndices.indexOf(index);
        if (~commentIndex) {
            this.commentIndices.splice(commentIndex, 1);
        }
        else {
            this.commentIndices.push(index);
        }
    };
    StylableComments.prototype.setLayerComments = function (value) {
        if (this.commentIndices.length === 0) {
            return value;
        }
        var layers = (0, stylable_shorthands_1.splitLayers)(value);
        var startOfCommentBlock = -1;
        var commentBlockOpen = false;
        for (var i = 0; i < layers.length; i++) {
            commentBlockOpen = startOfCommentBlock !== -1;
            if (this.isCommented(i)) {
                if (!commentBlockOpen) {
                    layers[i] = COMMENT_START + layers[i];
                    startOfCommentBlock = i;
                }
            }
            else if (commentBlockOpen) {
                layers[i] = COMMENT_END + layers[i];
                startOfCommentBlock = -1;
            }
        }
        commentBlockOpen = startOfCommentBlock !== -1;
        if (commentBlockOpen) {
            if (startOfCommentBlock > 0) {
                layers[startOfCommentBlock - 1] = layers[startOfCommentBlock - 1] + COMMENT_START;
                layers[startOfCommentBlock] = layers[startOfCommentBlock].slice(2);
            }
            layers[layers.length - 1] = layers[layers.length - 1] + COMMENT_END;
        }
        return layers.join(', ');
    };
    return StylableComments;
}());
exports.StylableComments = StylableComments;
// TODO: Make a version that is wrapped with splitLayers and gets a string value?
function layerCommentIndices(layers) {
    if (layers.length === 0) {
        return null;
    }
    var indices = [];
    var inCommentBlock = false;
    for (var i = 0; i < layers.length; i++) {
        var layer = layers[i];
        var commentOpenIndex = layer.indexOf(COMMENT_START);
        var commentCloseIndex = layer.indexOf(COMMENT_END);
        var commentOpens = commentOpenIndex !== -1;
        var commentCloses = commentCloseIndex !== -1;
        var commentOpensAtLineStart = commentOpenIndex === 0;
        var commentClosesAtLineStart = commentCloseIndex === 0;
        var commentOpensAtLineEnd = commentOpenIndex === layer.length - COMMENT_START.length;
        var commentClosesAtLineEnd = commentCloseIndex === layer.length - COMMENT_END.length;
        var commentOpensInsideLine = !commentOpensAtLineStart && !commentOpensAtLineEnd;
        var commentClosesInsideLine = !commentClosesAtLineStart && !commentClosesAtLineEnd;
        if (layers.length === 1 && commentOpensAtLineStart && commentClosesAtLineEnd) {
            return [i];
        }
        if ((inCommentBlock && !commentClosesAtLineStart) || (!inCommentBlock && commentOpensAtLineStart)) {
            indices.push(i);
        }
        if (commentCloses) {
            if (!inCommentBlock || commentOpensAtLineStart || commentClosesInsideLine) {
                return null;
            }
            inCommentBlock = false;
        }
        if (commentOpens) {
            if (inCommentBlock || (commentCloses && !commentClosesAtLineStart) || commentOpensInsideLine) {
                return null;
            }
            inCommentBlock = true;
        }
    }
    return !inCommentBlock ? indices : null;
}
exports.layerCommentIndices = layerCommentIndices;
function filterComments(value) {
    return value.replace(VALUE_WITHIN_COMMENT_REGEX, '');
}
exports.filterComments = filterComments;
function removeComments(value) {
    return value.replace(COMMENT_START_REGEX, '').replace(COMMENT_END_REGEX, '');
}
exports.removeComments = removeComments;
//# sourceMappingURL=stylable-comments.js.map